module.exports = __webpack_public_path__ + "static/media/3-iron.bde585de.png";